/*
 * @Author: 丨小小风离丨
 * @Date: 2024-05-15 09:25:39
 * @LastEditTime: 2024-10-17 16:54:51
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\components\countdownTimer\index.tsx
 * @Description: 
 */
import { useEffect, useState } from "react";

function CountdownTimer({ endDate }) {
    const [timeLeft, setTimeLeft] = useState<any>(null);

    useEffect(() => {
        let intervalId = null;

        const tick = () => {
            const now = new Date().getTime();
            const tempDate: any = new Date(endDate + 'T23:59:59'); // 设置为当天23:59:59
            const distance = tempDate - now;

            if (distance < 0) {
                // 如果已经过去，可以设置为0或显示'已结束'  
                setTimeLeft('');
                clearInterval(intervalId);
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // setTimeLeft(`${days}天 ${hours}时 ${minutes}分 ${seconds}秒`);
            setTimeLeft(`${String(hours + (days * 24)).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);
            setTimeLeft(`${days > 0 ? days + '天 ' : ''}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} `);
        };
        
        if (endDate) {
            // 初始设置倒计时  
            tick();
            // 每秒更新一次  
            intervalId = setInterval(tick, 1000);
        }

        // 清除计时器  
        return () => clearInterval(intervalId);
    }, [endDate]); // endDate变化时，重新计算倒计时  

    return <span>{timeLeft}</span>;
}

export default CountdownTimer;
